import React from "react";
import { Navigate } from "react-router";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  const token = localStorage.getItem("token");
  const gender = user?.gender || localStorage.getItem("gender");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!gender) {
    return <Navigate to="/profile" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
